const rgpdType = Object.freeze({
    RESIDENT: '1',
    TERTIARY: '2',
    PROVIDER: '3',
    CUSTOM: '0',
});

export default rgpdType;
